var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __esm = (fn, res) => function __init() {
  return fn && (res = (0, fn[__getOwnPropNames(fn)[0]])(fn = 0)), res;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};

// src/providers/MustacheTemplateProvider.ts
var MustacheTemplateProvider_exports = {};
__export(MustacheTemplateProvider_exports, {
  MustacheTemplateProvider: () => MustacheTemplateProvider
});
import Mustache from "mustache";
var _MustacheTemplateProvider, MustacheTemplateProvider;
var init_MustacheTemplateProvider = __esm({
  "src/providers/MustacheTemplateProvider.ts"() {
    "use strict";
    _MustacheTemplateProvider = class _MustacheTemplateProvider {
      /**
      * Constructor
      * @param max_passes - Maximum number of resolution passes (default: 1)
      */
      constructor(max_passes = 1) {
        __publicField(this, "max_passes");
        this.max_passes = max_passes;
        Mustache.escape = (text) => {
          return text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
        };
      }
      /**
      * Resolve template with given context
      * 
      * @param template - Mustache template string
      * @param context - Data context for template resolution
      * @returns Resolved template string
      */
      resolve(template, context) {
        if (!template) {
          return "";
        }
        if (!template.includes("{{")) {
          return template;
        }
        try {
          let result = template;
          for (let pass = 0; pass < this.max_passes; pass++) {
            const resolved = Mustache.render(result, context);
            if (resolved === result) {
              break;
            }
            result = resolved;
          }
          return result;
        } catch (error) {
          throw new Error(`Template resolution failed: ${error instanceof Error ? error.message : String(error)}`);
        }
      }
    };
    __name(_MustacheTemplateProvider, "MustacheTemplateProvider");
    MustacheTemplateProvider = _MustacheTemplateProvider;
  }
});

// src/index.ts
import "reflect-metadata";

// src/decorators/index.ts
import "reflect-metadata";

// src/types/Schema.ts
var DataType = /* @__PURE__ */ function(DataType2) {
  DataType2["STRING"] = "string";
  DataType2["INTEGER"] = "integer";
  DataType2["NUMBER"] = "number";
  DataType2["BOOLEAN"] = "boolean";
  DataType2["OBJECT"] = "object";
  DataType2["ARRAY"] = "array";
  return DataType2;
}({});
var FieldType = /* @__PURE__ */ function(FieldType2) {
  FieldType2["TEXT"] = "text";
  FieldType2["TEXTAREA"] = "textarea";
  FieldType2["NUMBER"] = "number";
  FieldType2["INTEGER"] = "integer";
  FieldType2["BOOLEAN"] = "boolean";
  FieldType2["EMAIL"] = "email";
  FieldType2["URL"] = "url";
  FieldType2["IMAGE"] = "image";
  FieldType2["FILE"] = "file";
  FieldType2["DATE"] = "date";
  FieldType2["DATE_TIME"] = "datetime";
  FieldType2["SELECT"] = "select";
  FieldType2["RADIO"] = "radio";
  FieldType2["CHECKBOX"] = "checkbox";
  FieldType2["COLOR"] = "color";
  FieldType2["FORM"] = "form";
  FieldType2["REPEATER"] = "repeater";
  FieldType2["MODEL_REPEATER"] = "model_repeater";
  return FieldType2;
}({});

// src/decorators/validators.ts
import "reflect-metadata";
var EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
var UUID_V4_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
function isValidUrl(value) {
  try {
    const url = new URL(value);
    return url.protocol === "http:" || url.protocol === "https:";
  } catch (e) {
    return false;
  }
}
__name(isValidUrl, "isValidUrl");
function validateValue(value, validator, fieldName) {
  if (value === null || value === void 0) {
    return null;
  }
  const { type, constraint, message } = validator;
  switch (type) {
    case "email":
      if (typeof value !== "string" || !EMAIL_REGEX.test(value)) {
        return message || `${fieldName} must be a valid email address`;
      }
      break;
    case "url":
      if (typeof value !== "string" || !isValidUrl(value)) {
        return message || `${fieldName} must be a valid URL`;
      }
      break;
    case "uuid":
      if (typeof value !== "string" || !UUID_V4_REGEX.test(value)) {
        return message || `${fieldName} must be a valid UUID`;
      }
      break;
    case "regex":
      if (typeof value !== "string" || !constraint.test(value)) {
        return message || `${fieldName} must match pattern ${constraint}`;
      }
      break;
    case "minLength":
      if (typeof value !== "string" || value.length < constraint) {
        return message || `${fieldName} must be at least ${constraint} characters`;
      }
      break;
    case "maxLength":
      if (typeof value !== "string" || value.length > constraint) {
        return message || `${fieldName} must be at most ${constraint} characters`;
      }
      break;
    case "min":
      if (typeof value !== "number" || value < constraint) {
        return message || `${fieldName} must be at least ${constraint}`;
      }
      break;
    case "max":
      if (typeof value !== "number" || value > constraint) {
        return message || `${fieldName} must be at most ${constraint}`;
      }
      break;
    case "int":
      if (typeof value !== "number" || !Number.isInteger(value)) {
        return message || `${fieldName} must be an integer`;
      }
      break;
    case "positive":
      if (typeof value !== "number" || value <= 0) {
        return message || `${fieldName} must be a positive number`;
      }
      break;
    case "negative":
      if (typeof value !== "number" || value >= 0) {
        return message || `${fieldName} must be a negative number`;
      }
      break;
  }
  return null;
}
__name(validateValue, "validateValue");
function addValidatorMetadata(target, propertyKey, type, constraint, options) {
  if (!target.constructor._validators) {
    target.constructor._validators = [];
  }
  target.constructor._validators.push({
    name: propertyKey,
    type,
    constraint,
    message: options == null ? void 0 : options.message
  });
}
__name(addValidatorMetadata, "addValidatorMetadata");
function Email(options) {
  return function(target, propertyKey) {
    addValidatorMetadata(target, propertyKey, "email", void 0, options);
  };
}
__name(Email, "Email");
function Url(options) {
  return function(target, propertyKey) {
    addValidatorMetadata(target, propertyKey, "url", void 0, options);
  };
}
__name(Url, "Url");
function Uuid(options) {
  return function(target, propertyKey) {
    addValidatorMetadata(target, propertyKey, "uuid", void 0, options);
  };
}
__name(Uuid, "Uuid");
function Regex(pattern, options) {
  if (!(pattern instanceof RegExp)) {
    throw new Error("@Regex requires a valid RegExp pattern");
  }
  const src = pattern.source;
  if (/\([^)]*[+*]\)[+*]|\([^)]*\|[^)]*\)[+*]/.test(src)) {
    console.warn(`[@qwickapps/schema] Warning: Regex pattern may have ReDoS vulnerability: ${src}. Avoid nested quantifiers like (a+)+ or alternation with quantifiers like (a|b)+`);
  }
  return function(target, propertyKey) {
    addValidatorMetadata(target, propertyKey, "regex", pattern, options);
  };
}
__name(Regex, "Regex");
function MinLength(min, options) {
  if (typeof min !== "number" || min < 0) {
    throw new Error("@MinLength requires a non-negative number");
  }
  return function(target, propertyKey) {
    addValidatorMetadata(target, propertyKey, "minLength", min, options);
  };
}
__name(MinLength, "MinLength");
function MaxLength(max, options) {
  if (typeof max !== "number" || max < 0) {
    throw new Error("@MaxLength requires a non-negative number");
  }
  return function(target, propertyKey) {
    addValidatorMetadata(target, propertyKey, "maxLength", max, options);
  };
}
__name(MaxLength, "MaxLength");
function Min(min, options) {
  if (typeof min !== "number") {
    throw new Error("@Min requires a number");
  }
  return function(target, propertyKey) {
    addValidatorMetadata(target, propertyKey, "min", min, options);
  };
}
__name(Min, "Min");
function Max(max, options) {
  if (typeof max !== "number") {
    throw new Error("@Max requires a number");
  }
  return function(target, propertyKey) {
    addValidatorMetadata(target, propertyKey, "max", max, options);
  };
}
__name(Max, "Max");
function Int(options) {
  return function(target, propertyKey) {
    addValidatorMetadata(target, propertyKey, "int", void 0, options);
  };
}
__name(Int, "Int");
function Positive(options) {
  return function(target, propertyKey) {
    addValidatorMetadata(target, propertyKey, "positive", void 0, options);
  };
}
__name(Positive, "Positive");
function Negative(options) {
  return function(target, propertyKey) {
    addValidatorMetadata(target, propertyKey, "negative", void 0, options);
  };
}
__name(Negative, "Negative");
function Transform(fn) {
  if (typeof fn !== "function") {
    throw new Error("@Transform requires a function");
  }
  return function(target, propertyKey) {
    if (!target.constructor._transforms) {
      target.constructor._transforms = [];
    }
    target.constructor._transforms.push({
      name: propertyKey,
      transform: fn
    });
  };
}
__name(Transform, "Transform");
function Validate(validator, options) {
  if (typeof validator !== "function") {
    throw new Error("@Validate requires a validator function");
  }
  return function(constructor) {
    if (!constructor._classValidators) {
      constructor._classValidators = [];
    }
    constructor._classValidators.push({
      validator,
      message: (options == null ? void 0 : options.message) || "Validation failed",
      fields: options == null ? void 0 : options.fields
    });
    return constructor;
  };
}
__name(Validate, "Validate");
function applyTransforms(data, transforms) {
  if (!transforms || transforms.length === 0) {
    return data;
  }
  const transformed = {
    ...data
  };
  for (const { name, transform } of transforms) {
    if (name in transformed) {
      try {
        transformed[name] = transform(transformed[name], transformed);
      } catch (error) {
        console.warn(`[@qwickapps/schema] Transform failed for field '${name}':`, error instanceof Error ? error.message : error);
      }
    }
  }
  return transformed;
}
__name(applyTransforms, "applyTransforms");
function runValidators(data, validators) {
  if (!validators || validators.length === 0) {
    return [];
  }
  const errors = [];
  for (const validator of validators) {
    const value = data[validator.name];
    const error = validateValue(value, validator, validator.name);
    if (error) {
      errors.push(error);
    }
  }
  return errors;
}
__name(runValidators, "runValidators");
function runClassValidators(data, classValidators) {
  if (!classValidators || classValidators.length === 0) {
    return [];
  }
  const errors = [];
  for (const { validator, message, fields } of classValidators) {
    try {
      const result = validator(data);
      if (result === false) {
        const errorMessage = (fields == null ? void 0 : fields.length) ? `${fields.join(", ")}: ${message}` : message;
        errors.push(errorMessage);
      } else if (typeof result === "string") {
        const errorMessage = (fields == null ? void 0 : fields.length) ? `${fields.join(", ")}: ${result}` : result;
        errors.push(errorMessage);
      }
    } catch (error) {
      errors.push(`Validation error: ${error.message}`);
    }
  }
  return errors;
}
__name(runClassValidators, "runClassValidators");

// src/decorators/index.ts
function Field(options = {}) {
  return function(target, propertyKey) {
    var _a;
    if (!target.constructor._fields) {
      target.constructor._fields = [];
    }
    const designType = Reflect.getMetadata("design:type", target, propertyKey);
    let dataType = options.dataType;
    if (!dataType && designType) {
      if (designType === String)
        dataType = DataType.STRING;
      else if (designType === Number)
        dataType = DataType.NUMBER;
      else if (designType === Boolean)
        dataType = DataType.BOOLEAN;
      else if (designType === Array)
        dataType = DataType.ARRAY;
      else if (designType === Object)
        dataType = DataType.OBJECT;
    }
    target.constructor._fields.push({
      name: propertyKey,
      dataType,
      required: (_a = options.required) != null ? _a : false,
      defaultValue: options.defaultValue,
      type: options.type,
      ...options
    });
  };
}
__name(Field, "Field");
function Editor(config) {
  return function(target, propertyKey) {
    if (!target.constructor._editors) {
      target.constructor._editors = [];
    }
    target.constructor._editors.push({
      name: propertyKey,
      ...config
    });
  };
}
__name(Editor, "Editor");
function Schema(nameOrOptions, version) {
  return function(constructor) {
    if (typeof nameOrOptions === "string") {
      constructor.prototype.constructor._schema = {
        name: nameOrOptions,
        version: version || "1.0.0"
      };
    } else {
      constructor.prototype.constructor._schema = {
        version: "1.0.0",
        ...nameOrOptions
      };
    }
    return constructor;
  };
}
__name(Schema, "Schema");

// src/models/Model.ts
import "reflect-metadata";
import { validate, getMetadataStorage } from "class-validator";
var _Model = class _Model {
  /**
  * Validate data against model decorator metadata and class-validator rules
  *
  * Validation order:
  * 1. Apply transforms
  * 2. Check required fields
  * 3. Run @Editor.validation constraints
  * 4. Run our validators (@Email, @Min, etc.)
  * 5. Run class-validator decorators
  * 6. Run cross-field validators (@Validate)
  */
  static async validate(data) {
    const fields = this._fields || [];
    const editors = this._editors || [];
    const validators = this._validators || [];
    const transforms = this._transforms || [];
    const classValidators = this._classValidators || [];
    const errors = [];
    const transformedData = applyTransforms(data, transforms);
    for (const field of fields) {
      if (field.required && transformedData[field.name] === void 0) {
        errors.push(`Field '${field.name}' is required`);
      }
    }
    for (const editor of editors) {
      const value = transformedData[editor.name];
      if (value !== void 0 && value !== null && editor.validation) {
        const { min, max, pattern, custom } = editor.validation;
        if (typeof value === "string") {
          if (min !== void 0 && value.length < min) {
            errors.push(`${editor.name} must be at least ${min} characters`);
          }
          if (max !== void 0 && value.length > max) {
            errors.push(`${editor.name} must be at most ${max} characters`);
          }
        }
        if (typeof value === "number") {
          if (min !== void 0 && value < min) {
            errors.push(`${editor.name} must be at least ${min}`);
          }
          if (max !== void 0 && value > max) {
            errors.push(`${editor.name} must be at most ${max}`);
          }
        }
        if (pattern && typeof value === "string" && !pattern.test(value)) {
          errors.push(`${editor.name} must match pattern ${pattern}`);
        }
        if (custom) {
          const customResult = custom(value);
          if (customResult !== true) {
            errors.push(typeof customResult === "string" ? customResult : `${editor.name} failed custom validation`);
          }
        }
      }
    }
    const validatorErrors = runValidators(transformedData, validators);
    errors.push(...validatorErrors);
    const instance = new this();
    Object.assign(instance, transformedData);
    let validationErrors = [];
    try {
      validationErrors = await validate(instance, {
        forbidUnknownValues: false
      });
    } catch (error) {
      errors.push("Validation failed: " + error.message);
    }
    for (const error of validationErrors) {
      if (error.constraints) {
        errors.push(...Object.values(error.constraints));
      }
    }
    if (errors.length === 0 && classValidators.length > 0) {
      const classValidatorErrors = runClassValidators(transformedData, classValidators);
      errors.push(...classValidatorErrors);
    }
    return {
      isValid: errors.length === 0,
      errors,
      validationErrors
    };
  }
  /**
  * Synchronous validation (without class-validator async rules)
  *
  * Runs all validations except async class-validator rules.
  */
  static validateSync(data) {
    const fields = this._fields || [];
    const editors = this._editors || [];
    const validators = this._validators || [];
    const transforms = this._transforms || [];
    const classValidators = this._classValidators || [];
    const errors = [];
    const transformedData = applyTransforms(data, transforms);
    for (const field of fields) {
      if (field.required && transformedData[field.name] === void 0) {
        errors.push(`Field '${field.name}' is required`);
      }
    }
    for (const editor of editors) {
      const value = transformedData[editor.name];
      if (value !== void 0 && value !== null && editor.validation) {
        const { min, max, pattern, custom } = editor.validation;
        if (typeof value === "string") {
          if (min !== void 0 && value.length < min) {
            errors.push(`${editor.name} must be at least ${min} characters`);
          }
          if (max !== void 0 && value.length > max) {
            errors.push(`${editor.name} must be at most ${max} characters`);
          }
        }
        if (typeof value === "number") {
          if (min !== void 0 && value < min) {
            errors.push(`${editor.name} must be at least ${min}`);
          }
          if (max !== void 0 && value > max) {
            errors.push(`${editor.name} must be at most ${max}`);
          }
        }
        if (pattern && typeof value === "string" && !pattern.test(value)) {
          errors.push(`${editor.name} must match pattern ${pattern}`);
        }
        if (custom) {
          const customResult = custom(value);
          if (customResult !== true) {
            errors.push(typeof customResult === "string" ? customResult : `${editor.name} failed custom validation`);
          }
        }
      }
    }
    const validatorErrors = runValidators(transformedData, validators);
    errors.push(...validatorErrors);
    if (errors.length === 0 && classValidators.length > 0) {
      const classValidatorErrors = runClassValidators(transformedData, classValidators);
      errors.push(...classValidatorErrors);
    }
    return {
      isValid: errors.length === 0,
      errors
    };
  }
  /**
  * Extract schema metadata from decorators and class-validator rules
  */
  static getSchema() {
    const fields = this._fields || [];
    const editors = this._editors || [];
    const validators = this._validators || [];
    const schema = this._schema || {
      name: this.name,
      version: "1.0.0"
    };
    const classValidatorMetadata = getMetadataStorage();
    const schemaFields = fields.map((field) => {
      const editor = editors.find((e) => e.name === field.name);
      const fieldValidators = validators.filter((v) => v.name === field.name);
      const validations = classValidatorMetadata.getTargetValidationMetadatas(this, this.prototype, false, false).filter((meta) => meta.propertyName === field.name);
      const classValidatorRules = validations.map((meta) => ({
        type: meta.type,
        constraints: meta.constraints
      }));
      const ourValidatorRules = fieldValidators.map((v) => ({
        type: v.type,
        constraint: v.constraint,
        message: v.message
      }));
      const allValidationRules = [
        ...ourValidatorRules,
        ...classValidatorRules
      ];
      return {
        name: field.name,
        data_type: field.dataType,
        required: field.required || false,
        defaultValue: field.defaultValue,
        type: field.type,
        editor: editor ? {
          field_type: editor.field_type,
          label: editor.label,
          description: editor.description,
          placeholder: editor.placeholder,
          help_text: editor.help_text,
          validation: editor.validation
        } : void 0,
        // Add all validation rules if any
        ...allValidationRules.length > 0 && {
          validation: allValidationRules
        }
      };
    });
    return {
      name: schema.name,
      version: schema.version || "1.0.0",
      description: schema.description,
      fields: schemaFields
    };
  }
  /**
  * Create an instance with default values applied
  */
  static createWithDefaults(data = {}) {
    const instance = new this();
    const fields = this._fields || [];
    for (const field of fields) {
      if (field.defaultValue !== void 0 && data[field.name] === void 0) {
        instance[field.name] = field.defaultValue;
      }
    }
    Object.assign(instance, data);
    return instance;
  }
  // ===========================================================================
  // Schema Composition Methods
  // ===========================================================================
  /**
  * Create a partial schema where all fields are optional
  *
  * @example
  * ```typescript
  * const UpdateUserSchema = UserModel.partial();
  * // All fields from UserModel are now optional
  * ```
  */
  static partial() {
    const schema = this.getSchema();
    return {
      ...schema,
      name: `Partial${schema.name}`,
      fields: schema.fields.map((field) => ({
        ...field,
        required: false
      }))
    };
  }
  /**
  * Create a schema with only the specified fields
  *
  * @example
  * ```typescript
  * const PublicUserSchema = UserModel.pick('name', 'email', 'avatar');
  * // Only includes name, email, and avatar fields
  * ```
  */
  static pick(...keys) {
    const schema = this.getSchema();
    const keySet = new Set(keys);
    return {
      ...schema,
      name: `Pick${schema.name}`,
      fields: schema.fields.filter((field) => keySet.has(field.name))
    };
  }
  /**
  * Create a schema excluding the specified fields
  *
  * @example
  * ```typescript
  * const CreateUserSchema = UserModel.omit('id', 'createdAt', 'updatedAt');
  * // Excludes id, createdAt, and updatedAt fields
  * ```
  */
  static omit(...keys) {
    const schema = this.getSchema();
    const keySet = new Set(keys);
    return {
      ...schema,
      name: `Omit${schema.name}`,
      fields: schema.fields.filter((field) => !keySet.has(field.name))
    };
  }
  /**
  * Create a schema with additional fields
  *
  * @example
  * ```typescript
  * const AdminUserSchema = UserModel.extend({
  *   permissions: { type: DataType.ARRAY, required: true },
  *   department: { type: DataType.STRING, required: false }
  * });
  * // Includes all UserModel fields plus permissions and department
  * ```
  */
  static extend(extensions) {
    const schema = this.getSchema();
    const newFields = Object.entries(extensions).map(([name, def]) => {
      var _a;
      return {
        name,
        data_type: typeof def.type === "string" && Object.values(DataType).includes(def.type) ? def.type : DataType.OBJECT,
        required: (_a = def.required) != null ? _a : false,
        defaultValue: def.defaultValue,
        type: typeof def.type === "string" ? def.type : void 0
      };
    });
    return {
      ...schema,
      name: `Extended${schema.name}`,
      fields: [
        ...schema.fields,
        ...newFields
      ]
    };
  }
  /**
  * Validate data against a composed schema (partial, pick, omit, extend)
  *
  * Since composed schemas are SchemaDefinition objects (not classes),
  * this static method validates data against a schema definition.
  *
  * @example
  * ```typescript
  * const UpdateUserSchema = UserModel.partial();
  * const result = Model.validateAgainstSchema({ name: 'John' }, UpdateUserSchema);
  * ```
  */
  static validateAgainstSchema(data, schema) {
    var _a;
    const errors = [];
    for (const field of schema.fields) {
      const value = data[field.name];
      if (field.required && value === void 0) {
        errors.push(`Field '${field.name}' is required`);
        continue;
      }
      if (value === void 0) {
        continue;
      }
      if ((_a = field.editor) == null ? void 0 : _a.validation) {
        const { min, max, pattern } = field.editor.validation;
        if (typeof value === "string") {
          if (min !== void 0 && value.length < min) {
            errors.push(`${field.name} must be at least ${min} characters`);
          }
          if (max !== void 0 && value.length > max) {
            errors.push(`${field.name} must be at most ${max} characters`);
          }
        }
        if (typeof value === "number") {
          if (min !== void 0 && value < min) {
            errors.push(`${field.name} must be at least ${min}`);
          }
          if (max !== void 0 && value > max) {
            errors.push(`${field.name} must be at most ${max}`);
          }
        }
        if (pattern && typeof value === "string" && !pattern.test(value)) {
          errors.push(`${field.name} must match pattern ${pattern}`);
        }
      }
    }
    return {
      isValid: errors.length === 0,
      errors
    };
  }
};
__name(_Model, "Model");
var Model = _Model;

// src/builders/SchemaBuilder.ts
var _FieldBuilder = class _FieldBuilder {
  constructor(name, dataType) {
    __publicField(this, "field", {});
    this.field.name = name;
    this.field.data_type = dataType;
    this.field.required = false;
  }
  /**
  * Mark field as required
  */
  required(required = true) {
    this.field.required = required;
    return this;
  }
  /**
  * Set default value for the field
  */
  defaultValue(value) {
    this.field.defaultValue = value;
    return this;
  }
  /**
  * Set the field type (for nested objects/arrays)
  */
  type(type) {
    this.field.type = type;
    return this;
  }
  /**
  * Configure the editor settings
  */
  editor(config) {
    this.field.editor = {
      field_type: FieldType.TEXT,
      label: this.field.name || "",
      description: "",
      ...config
    };
    return this;
  }
  /**
  * Quick editor setup for text fields
  */
  textEditor(label, description, placeholder) {
    return this.editor({
      field_type: FieldType.TEXT,
      label,
      description,
      placeholder
    });
  }
  /**
  * Quick editor setup for textarea fields
  */
  textareaEditor(label, description, placeholder) {
    return this.editor({
      field_type: FieldType.TEXTAREA,
      label,
      description,
      placeholder
    });
  }
  /**
  * Quick editor setup for select fields
  */
  selectEditor(label, description, options) {
    return this.editor({
      field_type: FieldType.SELECT,
      label,
      description,
      validation: {
        options
      }
    });
  }
  /**
  * Add validation rules
  */
  validation(rules) {
    if (!this.field.editor) {
      this.field.editor = {
        field_type: FieldType.TEXT,
        label: this.field.name || "",
        description: ""
      };
    }
    this.field.editor.validation = rules;
    return this;
  }
  /**
  * Build the final FieldDefinition
  */
  build() {
    var _a;
    if (!this.field.name || !this.field.data_type) {
      throw new Error("Field name and data_type are required");
    }
    return {
      name: this.field.name,
      data_type: this.field.data_type,
      required: (_a = this.field.required) != null ? _a : false,
      defaultValue: this.field.defaultValue,
      type: this.field.type,
      editor: this.field.editor
    };
  }
};
__name(_FieldBuilder, "FieldBuilder");
var FieldBuilder = _FieldBuilder;
var _SchemaBuilder = class _SchemaBuilder {
  constructor(name, version = "1.0.0") {
    __publicField(this, "schema", {
      fields: []
    });
    this.schema.name = name;
    this.schema.version = version;
  }
  /**
  * Set schema description
  */
  description(description) {
    this.schema.description = description;
    return this;
  }
  /**
  * Add a field to the schema
  */
  field(name, dataType) {
    const fieldBuilder = new FieldBuilder(name, dataType);
    const originalBuild = fieldBuilder.build.bind(fieldBuilder);
    fieldBuilder.build = () => {
      const field = originalBuild();
      this.schema.fields.push(field);
      return field;
    };
    return fieldBuilder;
  }
  /**
  * Add a pre-built field
  */
  addField(field) {
    this.schema.fields.push(field);
    return this;
  }
  /**
  * Add multiple fields at once
  */
  addFields(fields) {
    this.schema.fields.push(...fields);
    return this;
  }
  /**
  * Add schema dependencies
  */
  uses(...schemaNames) {
    if (!this.schema.uses) {
      this.schema.uses = [];
    }
    this.schema.uses.push(...schemaNames);
    return this;
  }
  /**
  * Build the final Schema
  */
  build() {
    if (!this.schema.name || !this.schema.version) {
      throw new Error("Schema name and version are required");
    }
    if (!this.schema.fields || this.schema.fields.length === 0) {
      throw new Error("Schema must have at least one field");
    }
    return {
      name: this.schema.name,
      version: this.schema.version,
      description: this.schema.description,
      uses: this.schema.uses,
      models: this.schema.models,
      fields: this.schema.fields
    };
  }
};
__name(_SchemaBuilder, "SchemaBuilder");
var SchemaBuilder = _SchemaBuilder;
var Fields = {
  /**
  * Create a text field
  */
  text(name, label, required = false) {
    return new FieldBuilder(name, DataType.STRING).required(required).textEditor(label, `${label} text field`);
  },
  /**
  * Create a textarea field
  */
  textarea(name, label, required = false) {
    return new FieldBuilder(name, DataType.STRING).required(required).textareaEditor(label, `${label} textarea field`);
  },
  /**
  * Create a number field
  */
  number(name, label, required = false) {
    return new FieldBuilder(name, DataType.NUMBER).required(required).editor({
      field_type: FieldType.NUMBER,
      label,
      description: `${label} number field`
    });
  },
  /**
  * Create an integer field
  */
  integer(name, label, required = false) {
    return new FieldBuilder(name, DataType.INTEGER).required(required).editor({
      field_type: FieldType.INTEGER,
      label,
      description: `${label} integer field`
    });
  },
  /**
  * Create a boolean field
  */
  boolean(name, label, required = false) {
    return new FieldBuilder(name, DataType.BOOLEAN).required(required).editor({
      field_type: FieldType.BOOLEAN,
      label,
      description: `${label} boolean field`
    });
  },
  /**
  * Create a select field
  */
  select(name, label, options, required = false) {
    return new FieldBuilder(name, DataType.STRING).required(required).selectEditor(label, `Select ${label}`, options);
  },
  /**
  * Create an image field
  */
  image(name, label, required = false) {
    return new FieldBuilder(name, DataType.STRING).required(required).editor({
      field_type: FieldType.IMAGE,
      label,
      description: `${label} image field`
    });
  },
  /**
  * Create an array field
  */
  array(name, label, itemType, required = false) {
    return new FieldBuilder(name, DataType.ARRAY).required(required).type(itemType).editor({
      field_type: FieldType.REPEATER,
      label,
      description: `${label} array field`
    });
  }
};
function createSchema(name, version = "1.0.0") {
  return new SchemaBuilder(name, version);
}
__name(createSchema, "createSchema");

// src/providers/MemoryCacheProvider.ts
var _MemoryCacheProvider = class _MemoryCacheProvider {
  constructor(config = {}) {
    __publicField(this, "cache", /* @__PURE__ */ new Map());
    __publicField(this, "config");
    this.config = {
      maxSize: 100,
      defaultTtl: 5 * 60 * 1e3,
      enableLogging: false,
      ...config
    };
    this.log("MemoryCacheProvider initialized", {
      config: this.config
    });
  }
  /**
  * Get cached value by key
  * Returns null if not found or expired
  */
  get(key) {
    const entry = this.cache.get(key);
    if (!entry) {
      this.log(`Cache miss: ${key}`);
      return null;
    }
    const now = Date.now();
    const ttl = entry.ttl || this.config.defaultTtl;
    const isExpired = now - entry.timestamp > ttl;
    if (isExpired) {
      this.cache.delete(key);
      this.log(`Cache expired: ${key}`);
      return null;
    }
    this.cache.delete(key);
    this.cache.set(key, entry);
    this.log(`Cache hit: ${key}`);
    return entry.data;
  }
  /**
  * Set cached value with optional TTL
  */
  set(key, value, ttl) {
    if (this.cache.has(key)) {
      this.cache.delete(key);
    }
    if (this.cache.size >= this.config.maxSize) {
      const oldestKey = this.cache.keys().next().value;
      if (oldestKey) {
        this.cache.delete(oldestKey);
        this.log(`LRU evicted: ${oldestKey}`);
      }
    }
    const entry = {
      data: value,
      timestamp: Date.now(),
      ttl
    };
    this.cache.set(key, entry);
    this.log(`Cache set: ${key}`, {
      ttl: ttl || this.config.defaultTtl
    });
  }
  /**
  * Clear cache entry or all entries
  */
  clear(key) {
    if (key) {
      const deleted = this.cache.delete(key);
      if (deleted) {
        this.log(`Cache cleared: ${key}`);
      }
    } else {
      this.cache.clear();
      this.log("Cache cleared completely");
    }
  }
  /**
  * Get cache statistics
  */
  getStats() {
    return {
      size: this.cache.size,
      maxSize: this.config.maxSize,
      keys: Array.from(this.cache.keys())
    };
  }
  /**
  * Clean up expired entries
  * This can be called periodically to free memory
  */
  cleanup() {
    const now = Date.now();
    let removedCount = 0;
    for (const [key, entry] of this.cache.entries()) {
      const ttl = entry.ttl || this.config.defaultTtl;
      const isExpired = now - entry.timestamp > ttl;
      if (isExpired) {
        this.cache.delete(key);
        removedCount++;
      }
    }
    if (removedCount > 0) {
      this.log(`Cleanup removed ${removedCount} expired entries`);
    }
    return removedCount;
  }
  /**
  * Debug logging (only when enabled)
  */
  log(message, data) {
    if (this.config.enableLogging) {
      console.log(`[MemoryCacheProvider] ${message}`, data || "");
    }
  }
};
__name(_MemoryCacheProvider, "MemoryCacheProvider");
var MemoryCacheProvider = _MemoryCacheProvider;

// src/providers/CachedDataProvider.ts
var _CachedDataProvider = class _CachedDataProvider {
  constructor(provider, cacheOptions = true) {
    __publicField(this, "cacheProvider");
    __publicField(this, "provider");
    __publicField(this, "config");
    var _a, _b, _c;
    this.provider = provider;
    if (cacheOptions === false) {
      this.cacheProvider = null;
      this.config = {
        defaultTTL: 5 * 60 * 1e3,
        maxSize: 100,
        enableLogging: false
      };
    } else if (cacheOptions === true) {
      this.cacheProvider = new MemoryCacheProvider();
      this.config = {
        defaultTTL: 5 * 60 * 1e3,
        maxSize: 100,
        enableLogging: false
      };
    } else if ("get" in cacheOptions && "set" in cacheOptions) {
      this.cacheProvider = cacheOptions;
      this.config = {
        defaultTTL: 5 * 60 * 1e3,
        maxSize: 100,
        enableLogging: false
      };
    } else {
      const config = cacheOptions;
      this.cacheProvider = new MemoryCacheProvider({
        maxSize: config.maxSize,
        defaultTtl: config.defaultTTL,
        enableLogging: config.enableLogging
      });
      this.config = {
        defaultTTL: (_a = config.defaultTTL) != null ? _a : 5 * 60 * 1e3,
        maxSize: (_b = config.maxSize) != null ? _b : 100,
        enableLogging: (_c = config.enableLogging) != null ? _c : false
      };
    }
  }
  /**
  * Get single data item by slug with caching
  */
  async get(slug) {
    if (!this.cacheProvider) {
      return await this.provider.get(slug);
    }
    const cacheKey = `get:${slug}`;
    const cached = this.cacheProvider.get(cacheKey);
    if (cached) {
      this.log(`Cache hit for get(${slug})`);
      const baseResponse = await this.provider.get(slug);
      return {
        ...baseResponse,
        data: cached,
        cached: true
      };
    }
    this.log(`Cache miss for get(${slug}), fetching from provider`);
    const response = await this.provider.get(slug);
    if (response.data) {
      this.cacheProvider.set(cacheKey, response.data, this.config.defaultTTL);
    }
    return {
      ...response,
      cached: false
    };
  }
  /**
  * Select multiple data items with query options and caching
  */
  async select(schema, options = {}) {
    if (!this.cacheProvider) {
      return await this.provider.select(schema, options);
    }
    const cacheKey = `select:${schema}:${JSON.stringify(options)}`;
    const cached = this.cacheProvider.get(cacheKey);
    if (cached) {
      this.log(`Cache hit for select(${schema})`);
      const baseResponse = await this.provider.select(schema, options);
      return {
        ...baseResponse,
        data: cached,
        cached: true
      };
    }
    this.log(`Cache miss for select(${schema}), fetching from provider`);
    const response = await this.provider.select(schema, options);
    if (response.data) {
      this.cacheProvider.set(cacheKey, response.data, this.config.defaultTTL);
    }
    return {
      ...response,
      cached: false
    };
  }
  /**
  * Clear cache with optional key pattern
  */
  clearCache(key) {
    var _a, _b;
    if (!this.cacheProvider) {
      this.log("No cache provider, nothing to clear");
      return;
    }
    if (key) {
      if (key.includes("*")) {
        const stats = (_b = (_a = this.cacheProvider).getStats) == null ? void 0 : _b.call(_a);
        if (stats) {
          const pattern = key.replace(/\*/g, ".*");
          const regex = new RegExp(pattern);
          for (const cacheKey of stats.keys) {
            if (regex.test(cacheKey)) {
              this.cacheProvider.clear(cacheKey);
              this.log(`Cleared cache key: ${cacheKey}`);
            }
          }
        } else {
          this.log("Cache provider does not support pattern clearing");
        }
      } else {
        this.cacheProvider.clear(key);
        this.log(`Cleared cache key: ${key}`);
      }
    } else {
      this.cacheProvider.clear();
      this.log("Cleared all cache");
    }
  }
  /**
  * Get cache statistics
  */
  getCacheStats() {
    var _a, _b, _c, _d, _e, _f;
    if (!this.cacheProvider) {
      return {
        totalEntries: 0,
        validEntries: 0,
        expiredEntries: 0,
        maxSize: this.config.maxSize,
        defaultTTL: this.config.defaultTTL,
        cachingEnabled: false
      };
    }
    const stats = (_b = (_a = this.cacheProvider).getStats) == null ? void 0 : _b.call(_a);
    return {
      totalEntries: (_c = stats == null ? void 0 : stats.size) != null ? _c : 0,
      validEntries: (_d = stats == null ? void 0 : stats.size) != null ? _d : 0,
      expiredEntries: 0,
      maxSize: (_e = stats == null ? void 0 : stats.maxSize) != null ? _e : this.config.maxSize,
      defaultTTL: this.config.defaultTTL,
      cachingEnabled: true,
      keys: (_f = stats == null ? void 0 : stats.keys) != null ? _f : []
    };
  }
  /**
  * Manually set cache entry with custom TTL
  */
  setCacheEntryManually(key, data, ttl) {
    if (!this.cacheProvider) {
      this.log("No cache provider, cannot set cache entry manually");
      return;
    }
    this.cacheProvider.set(key, data, ttl || this.config.defaultTTL);
    this.log(`Manually set cache entry: ${key} (TTL: ${ttl || this.config.defaultTTL}ms)`);
  }
  /**
  * Debug logging
  */
  log(message) {
    if (this.config.enableLogging) {
      console.log(`[CachedDataProvider] ${message}`);
    }
  }
};
__name(_CachedDataProvider, "CachedDataProvider");
var CachedDataProvider = _CachedDataProvider;

// src/providers/JsonDataProvider.ts
var _JsonDataProvider = class _JsonDataProvider {
  /**
  * Constructor
  * @param data - Initial data object
  * @param resolve_mustache - Whether to resolve mustache templates in data (default: true)
  */
  constructor(data = {}, resolve_mustache = true, max_passes = 1) {
    __publicField(this, "data");
    data = this.convertDottedNotation(data.data || data);
    if (resolve_mustache) {
      const { MustacheTemplateProvider: MustacheTemplateProvider2 } = (init_MustacheTemplateProvider(), __toCommonJS(MustacheTemplateProvider_exports));
      const mustacheProvider = new MustacheTemplateProvider2(max_passes);
      for (const key of Object.keys(data)) {
        const item = data[key];
        if (typeof item === "string") {
          data[key] = mustacheProvider.resolve(item, data);
        } else if (typeof item === "object") {
          const itemStr = JSON.stringify(item);
          const resolvedStr = mustacheProvider.resolve(itemStr, data);
          data[key] = JSON.parse(resolvedStr);
        }
      }
    }
    this.data = data;
  }
  /**
  * Get single data item by slug
  */
  async get(slug) {
    const value = this.getValueByPath(slug);
    if (value === void 0) {
      return {
        data: void 0
      };
    }
    const instance = Array.isArray(value) ? value[0] : value;
    return {
      data: instance,
      cached: false,
      meta: {
        schema: this.inferModelName(slug),
        version: "1.0.0",
        slug
      }
    };
  }
  /**
  * Select multiple data items with query options
  */
  async select(schema, options = {}) {
    const cacheKey = `select:${schema}:${JSON.stringify(options)}`;
    const items = this.findItemsBySchema(schema);
    let filteredItems = items;
    if (options.filters) {
      filteredItems = this.applyFilters(filteredItems, options.filters);
    }
    if (options.sort && options.sort !== "none" && options.orderBy) {
      filteredItems = this.applySorting(filteredItems, options.orderBy, options.sort);
    }
    const total = filteredItems.length;
    const offset = options.offset || 0;
    const limit = options.limit || total;
    const paginatedItems = filteredItems.slice(offset, offset + limit);
    const instances = paginatedItems.map((item) => item);
    return {
      data: instances,
      cached: false,
      meta: {
        schema,
        version: "1.0.0",
        total,
        offset,
        limit: Math.min(limit, instances.length)
      }
    };
  }
  /**
  * Update the data source
  */
  updateData(newData) {
    this.data = this.convertDottedNotation(newData);
  }
  /**
  * Convert dotted notation keys to nested object structure
  * e.g., { 'company.tagline': {...} } becomes { company: { tagline: {...} } }
  */
  convertDottedNotation(data) {
    const result = {};
    for (const [key, value] of Object.entries(data)) {
      if (key.includes(".")) {
        const parts = key.split(".");
        let current = result;
        for (let i = 0; i < parts.length - 1; i++) {
          const part = parts[i];
          if (!current[part]) {
            current[part] = {};
          }
          current = current[part];
        }
        const finalKey = parts[parts.length - 1];
        current[finalKey] = value;
      } else {
        if (value && typeof value === "object" && !Array.isArray(value)) {
          result[key] = this.convertDottedNotation(value);
        } else {
          result[key] = value;
        }
      }
    }
    return result;
  }
  /**
  * Get value by dot-notation path (e.g., "products.1.name")
  */
  getValueByPath(path) {
    const parts = path.replace(/^\//, "").split(/[/.]/);
    let current = this.data;
    for (const part of parts) {
      if (current === null || current === void 0) {
        return void 0;
      }
      if (Array.isArray(current) && !isNaN(Number(part))) {
        current = current[Number(part)];
      } else if (typeof current === "object" && current !== null) {
        current = current[part];
      } else {
        return void 0;
      }
    }
    return current;
  }
  /**
  * Find all items that match a schema name
  */
  findItemsBySchema(schema) {
    const items = [];
    if (this.data[schema] && Array.isArray(this.data[schema])) {
      items.push(...this.data[schema]);
    }
    this.searchObjectForSchema(this.data, schema, items);
    return items;
  }
  /**
  * Recursively search object for items matching schema
  */
  searchObjectForSchema(obj, schema, results) {
    if (typeof obj !== "object" || obj === null)
      return;
    if (Array.isArray(obj)) {
      obj.forEach((item) => this.searchObjectForSchema(item, schema, results));
    } else {
      if (obj.modelName === schema || obj.schema === schema) {
        results.push(obj);
      }
      Object.values(obj).forEach((value) => {
        this.searchObjectForSchema(value, schema, results);
      });
    }
  }
  /**
  * Apply filters to items
  */
  applyFilters(items, filters) {
    return items.filter((item) => {
      return Object.entries(filters).every(([key, value]) => {
        const itemValue = this.getValueByPath.call({
          data: item
        }, key);
        return itemValue === value;
      });
    });
  }
  /**
  * Apply sorting to items
  */
  applySorting(items, orderBy, sort) {
    return [
      ...items
    ].sort((a, b) => {
      const aValue = this.getValueByPath.call({
        data: a
      }, orderBy);
      const bValue = this.getValueByPath.call({
        data: b
      }, orderBy);
      if (aValue < bValue)
        return sort === "asc" ? -1 : 1;
      if (aValue > bValue)
        return sort === "asc" ? 1 : -1;
      return 0;
    });
  }
  /**
  * Infer model name from slug path
  */
  inferModelName(slug) {
    const parts = slug.replace(/^\//, "").split("/");
    return parts[0] || "unknown";
  }
  /**
  * Generate slug for item
  */
  generateSlug(schema, index) {
    return `/${schema.toLowerCase()}/${index}`;
  }
};
__name(_JsonDataProvider, "JsonDataProvider");
var JsonDataProvider = _JsonDataProvider;

// src/providers/index.ts
init_MustacheTemplateProvider();
export {
  CachedDataProvider,
  DataType,
  Editor,
  Email,
  Field,
  FieldBuilder,
  FieldType,
  Fields,
  Int,
  JsonDataProvider,
  Max,
  MaxLength,
  MemoryCacheProvider,
  Min,
  MinLength,
  Model,
  MustacheTemplateProvider,
  Negative,
  Positive,
  Regex,
  Schema,
  SchemaBuilder,
  Transform,
  Url,
  Uuid,
  Validate,
  applyTransforms,
  createSchema,
  runClassValidators,
  runValidators,
  validateValue
};
